<template>
	<span :style="ansColor"><strong>{{answer}}</strong></span>
</template>

<script>
	export default {
		name: "yes-no",
		props: {val:{required:true}},
		computed:{
			answer(){
				if (this.val){
					return this.$t("attributes.yes");}
				else{
					return this.$t("attributes.no");
				}

			},
			ansColor(){
				if (this.val){
					return "color:blue; padding-right: 5px";}
				else{
					return "color:red; padding-right: 5px";
				}

			}
		}
	};
</script>

<style scoped>

</style>